import TopBar from "../components/TopBar";

export default function Placeholder({ title, note }: { title: string; note: string }) {
  return (
    <>
      <TopBar crumbs={[title]} />
      <div className="content">
        <div className="empty">
          <div className="big">🚧</div>
          <h2>{title}</h2>
          <div>{note}</div>
        </div>
      </div>
    </>
  );
}
